import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { LOGO_IMAGE, party } from '../data/party';
type LoginProps = {
  onUnlock: () => void;
};
export function Login({
  onUnlock
}: LoginProps) {
  const [password, setPassword] = useState('');
  const [hasError, setHasError] = useState(false);
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (password.trim().toLowerCase() === 'party2026') {
      onUnlock();
      return;
    }
    setHasError(true);
  };
  return <main className="flex min-h-screen w-full flex-col items-center justify-center bg-[var(--night)] px-5 py-12" data-id="element-56" data-mp="nvx8edc96dcs">
      <h1 className="sr-only" data-id="element-57" data-mp="sv9wf1ev1qgy">{party.name}</h1>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="w-full max-w-md" data-id="element-58" data-mp="sw1s0c8gjo78">
        <img src={LOGO_IMAGE} alt="Kanchella" className="mb-12 block h-auto w-full invert" data-id="element-59" data-mp="248krttwn7vey" />

        <form onSubmit={handleSubmit} className="mx-auto max-w-sm" data-id="element-60" data-mp="13012awd9i193">
          <label htmlFor="password" className="mb-3 block text-center text-sm font-semibold uppercase tracking-[0.2em] text-[var(--gold)]" data-id="element-61" data-mp="y3tu0wxe8dnz">
            Enter password
          </label>
          <div className="relative" data-id="element-62" data-mp="p1kmmfxf90et">
            <LockIcon className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-white/40" data-id="element-63" data-mp="p4q8zneo1o6u" />
            <input id="password" name="password" type="password" autoComplete="current-password" autoFocus required value={password} onChange={event => {
            setPassword(event.target.value);
            setHasError(false);
          }} aria-invalid={hasError} aria-describedby={hasError ? 'password-error' : undefined} className="w-full rounded-full border border-white/15 bg-white/5 py-3 pl-11 pr-4 text-center text-white outline-none transition-colors focus:border-[var(--gold)] focus:ring-2 focus:ring-[var(--gold)]/30" data-id="element-64" data-mp="fcsxsgnnqw84" />
          </div>

          {hasError ? <p id="password-error" role="alert" className="mt-3 text-center text-sm text-red-200" data-id="element-65" data-mp="38z3umau0ly68">
              That password isn’t right. Please try again.
            </p> : null}

          <motion.button type="submit" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="mt-5 w-full rounded-full bg-[var(--gold)] py-3 font-poster text-xl uppercase tracking-[0.15em] text-[var(--night)]" data-id="element-66" data-mp="5i56npngdpmh">
            Enter
          </motion.button>
        </form>
      </motion.div>
    </main>;
}